import { useEffect, useRef } from "react";
import isEqual from "lodash/isEqual";
import SelectFieldModal from "../../../components/organisms/AppModals/ServiceModals/SelectFieldModal";
import { FIELDS } from "../datamodels.constants";
import { EMPTY_ARRAY } from "../../../constants";

const { MODEL_NAME } = FIELDS;
const SelectFields = ({
  name,
  values,
  setFieldValue,
  collections,
  handleChange,
  nodes,
  edges,
}) => {
  const preSelectedValues = useRef(values[name]);
  const previousModelName = useRef(values.modelName);

  useEffect(() => {
    if (values[name] && !isEqual(preSelectedValues.current, values[name])) {
      preSelectedValues.current = values[name];
      handleChange(values[name], name);
    }
  }, [values, name, handleChange]);

  useEffect(() => {
    if (previousModelName.current !== values.modelName) {
      previousModelName.current = values.modelName;
      handleChange(EMPTY_ARRAY, name);
    }
  }, [values, name, handleChange]);

  return (
    <>
      {
        <SelectFieldModal
          name={name}
          fieldKey={name}
          values={values}
          collections={collections}
          btnText="Manage Updates"
          title="Select fields to update"
          description="Select fields to update"
          modelName={values[MODEL_NAME]}
          nodes={nodes}
          edges={edges}
          handleChange={handleChange}
        />
      }
    </>
  );
};

export default SelectFields;
